import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Footer from './components/Footer';
import DenialManagement from './components/DenialManagement';
import MedicalBilling from './components/MedicalBilling';
import MedicalCoding from './components/MedicalCoding';
import ArFollowUp from './components/ArFollowUp';
import Credentialing from './components/Credentialing';
import MedicalBillingAudit from './components/MedicalBillingAudit';
import StatesWeServe from './components/StatesWeServe';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import OutsourceMedicalBilling from './components/OutsourceMedicalBilling';
import BenefitsOfOutsourcing from './components/BenefitsOfOutsourcing';
import Career from './components/Career';
import Blog from './components/Blog';
import HIPAA from './components/HIPAA';
import ContactUs from './components/ContactUs';
import Illinois from './components/Illinois';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import GenericState from './components/GenericState';
function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/denials-management" element={<DenialManagement />} />
          <Route path="/services/medical-billing" element={<MedicalBilling />} />
          <Route path="/services/medical-coding" element={<MedicalCoding />} />
          <Route path="/services/ar-follow-up" element={<ArFollowUp />} />
          <Route path="/services/credentialing" element={<Credentialing />} />
          <Route path="/services/medical-billing-audit" element={<MedicalBillingAudit />} />
          <Route path="/states" element={<StatesWeServe />} />
          <Route path="/states/illinois" element={<Illinois />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/outsource-medical-billing" element={<OutsourceMedicalBilling />} />
          <Route path="/benefits-of-outsourcing" element={<BenefitsOfOutsourcing />} />
          <Route path="/career" element={<Career />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/hipaa" element={<HIPAA />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
           <Route path="/states/:stateName" element={<GenericState />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;